export const SIGN_UP_NOW            = 'sign_up_now';
export const SIGN_IN_WITH_DEFAULT   = 'sign_in_with_default';
export const SIGN_UP_WITH_GOOGLE    = 'sign_in_with_google';
export const SIGN_UP_WITH_MICROSOFT = 'sign_in_with_microsoft';
export const SIGN_UP_WITH_LINKINED  = 'sign_in_with_linkined';
export const SIGN_UP_WITH_FACEBOOK  = 'sign_in_with_facebook';
export const PRIVACY_POLICY         = 'privacy_policy';
export const TERM_OF_SERVICE        = 'term_of_service';

export const PROM1_DISPLAYED = 'prom1_displayed';
export const PROM2_DISPLAYED = 'prom2_displayed';
export const PROM2_CLICKED   = 'prom2_clicked';
export const PROM3_CLICKED   = 'prom3_clicked';
export const PROM4_CLICKED   = 'prom4_clicked';

export const ABOUT_FOXIT_SOFTWARE = 'about_foxit_software';
export const SIGN_IN              = 'sign_in';
export const SIGN_UP              = 'sign_up';
export const MY_ACCOUNT           = 'my_account';
export const EXIT                 = 'exit';
export const SUBSCRIBE            = 'subscribe';
export const SHARE_BUTTON         = 'share_button';
export const NOTIFICATION_BELL    = 'notification_bell';
export const TO_ADMIN_CONSOLE     = 'to_admin_console'

export const USER_TYPE_EDU                                  = 'USER_TYPE_EDU';
export const USER_TYPE_NON_EDU                              = 'USER_TYPE_NON_EDU';
export const SUBSCRIBED_NO_PLAN                             = 'SUBSCRIBED_NO_PLAN';
export const SUBSCRIBED_PLAN                                = 'SUBSCRIBED_PLAN';
export const REDEEM_SUBSCRIPTION_SUCCESS                    = 'REDEEM_SUBSCRIPTION_SUCCESS';
export const REDEEM_SUBSCRIPTION_KEY_INVALID                = 'REDEEM_SUBSCRIPTION_KEY_INVALID';
export const UPDATE_PASSWORD_SUCCESS                        = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_NAME_SUCCESS                            = 'UPDATE_NAME_SUCCESS';
export const PERMISSION_BY_DASHBOARD_LIMIT                  = 'PERMISSION_BY_DASHBOARD_LIMIT';
export const PERMISSION_BY_DASHBOARD_LIMIT_SUBSCRIPTION     = 'PERMISSION_BY_DASHBOARD_LIMIT_SUBSCRIPTION';


export const ENTER_REVIEW_MODE_SUCCESS     = 'enter_review_mode_success';
export const ENTER_REVIEW_MODE_FAILED      = 'enter_review_mode_failed';
export const CREATE_SHARED_LINK_SUCCESS    = 'create_shared_link_success';
export const CREATE_SHARED_LINK_FAILED     = 'create_shared_link_failed';
export const COPY_SHARED_LINK_SUCCESS      = 'copy_shared_link_success';
export const COPY_SHARED_LINK_FAILED       = 'copy_shared_link_failed';
export const SEND_FILE_AND_LINK_SUCCESS    = 'send_file_and_link_success';
export const SEND_FILE_AND_LINK_FAILED     = 'send_file_and_link_failed';
export const ADD_DEADLINE_SUCCESS          = 'add_deadline_success';
export const ADD_DEADLINE_FAILED           = 'add_deadline_failed';
export const ADD_MORE_PEOPLE_SUCCESS       = 'add_more_people_success';
export const ADD_MORE_PEOPLE_FAILED        = 'add_more_people_failed';
export const UNSHARE_FILE_SUCCESS          = 'unshare_file_success';
export const UNSHARE_FILE_FAILED           = 'unshare_file_failed';
export const DELETE_SHARED_FILE_SUCCESS    = 'delete_shared_file_success';
export const DELETE_SHARED_FILE_FAILED     = 'delete_shared_file_failed';
export const DOWNLOAD_FILE_SUCCESS         = 'download_file_success';
export const DOWNLOAD_FILE_FAILED          = 'download_file_failed';
export const REMOVE_ME_SUCCESS             = 'remove_me_success';
export const REMOVE_ME_FAILED              = 'remove_me_failed';

export const TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW                    = 'Token_expired_login_pop-up_window';
export const TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_SIGNIN_BUTTON      = 'Token_expired_login_pop-up_window_signin_button';
export const TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_CANCEL_BUTTON      = 'Token_expired_login_pop-up_window_cancel_button';
export const TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_SIGNIN_SUCCESSFUL  = 'Token_expired_login_pop-up_window_signin_successful';
export const TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_SIGNIN_INTERRUPTED = 'Token_expired_login_pop-up_window_signin_interrupted';
export const TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_LABEL              = 'Token_expired_login_pop-up_window';
